<template>
  <Panel>
    <div class="register" slot="panel">
      <a-row :gutter="[48,8]">
        <a-col :lg="{span: 24}">
          <div :class="['text-red weight-bold register-title',font40]">
            {{$root.language.homeRow17}} {{$root.language.homeRow18}}
            <div class="relative line"></div>
          </div>

          <div class="font-20 weight-bold margin-top-15">
            {{$root.language.homeRow19}}
            {{$root.language.homeRow20}}
            {{$root.language.homeRow21}}
          </div>

          <div class="text-center margin-top-15 font-16">
            <SkewButton @click="handleShow" class="weight-bold" width="220" :text="$root.language.homeRow26"></SkewButton>
          </div>
        </a-col>
      </a-row>

      <JoinUs ref="joinUs"></JoinUs>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import SkewButton from '@/components/button-skew'
import JoinUs from './join-us'
export default {
  components: {
    Panel,
    SkewButton,
    JoinUs
  },
  computed: {
    font40: function () {
      return this.$root.isEnglish ? 'font-40' : 'font-32'
    }
  },

  methods: {
    handleShow () {
      this.$refs.joinUs.show()
    }
  }
}

</script>

<style scoped>
  .register {
    margin: 60px 0;
    padding: 50px;
    background: #ededed;
  }

  .line {
    padding-bottom: 20px;
    border-bottom: 5px solid #a3a3a3;
  }

  .line::before {
    content: '';
    display: inline-block;
    width: 150px;
    height: 5px;
    position: absolute;
    bottom: -5px;
    left: -150px;
    background: #a3a3a3;
  }

  @media (max-width: 578px) {
    .register {
      margin: 0;
      padding: 0 10px;
    }

    .register-title {
      font-size: 2rem;
    }
  }
</style>
